import { render, staticRenderFns } from "./StopN_Details.vue?vue&type=template&id=0165b3d9"
import script from "./StopN_Details.vue?vue&type=script&lang=js"
export * from "./StopN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports